import React, { useContext, useRef, useState, useEffect } from "react";
import { motion } from "framer-motion";
import styles from "./heroHomeSec.module.css";

import MaskedImageFadeReveal from "../Glsl/MaskedImageReveal";
import StarBorder from "../EffectComponent/StarBorder/StarBorder";
import SplitText from "../EffectComponent/SplitText/SplitText";
// import ShaderScene from "../Glsl/ShaderScene";
import VideoCanvas from "../droneRender/VideoCanvas";

import { HomeContext } from "../../utils/homeContext/HomeContext";

const HeroHomeSec = () => {
  const { acfData } = useContext(HomeContext);
  const heroRef = useRef(null);
  const videoRef = useRef(null);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [assetsLoaded, setAssetsLoaded] = useState(false);

  // Debounced window resize handling
  useEffect(() => {
    let resizeTimeout;
    const handleResize = () => {
      clearTimeout(resizeTimeout);
      resizeTimeout = setTimeout(() => {
        setIsMobile(window.innerWidth < 768);
      }, 200);
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // Fix video playback on asset load
  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.load();
      videoRef.current.play().catch((err) =>
        console.error("Video play failed:", err)
      );
    }
  }, [assetsLoaded]);

  // Preload assets (image and video) without using useCallback
  useEffect(() => {
    if (!acfData) return;
    const image = new Image();
    image.src = acfData.heroBackgroundImage || "";

    const video = document.createElement("video");
    video.src =
      "https://studiomaamangala.com/wp-content/uploads/2025/02/drone.webm";

    Promise.all([
      new Promise((res) => (image.onload = res)),
      new Promise((res) => (video.onloadeddata = res)),
    ])
      .then(() => setAssetsLoaded(true))
      .catch((error) => console.error("Error loading assets:", error));
  }, [acfData]);


  // Return null until data and assets are ready
  if (!acfData || !assetsLoaded) return null;

  return (
    <motion.div
      ref={heroRef}
      className={styles.HeroSection}
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 1.5, ease: "easeOut" }}
    >
      {/* Optionally, render additional components on desktop */}
      {!isMobile && acfData.heroBackgroundImage && (
        <motion.div transition={{ type: "spring", stiffness: 200, damping: 30 }}>
          <MaskedImageFadeReveal
            ref={heroRef}
            hoverimage={acfData.heroBackgroundImage}
          />
        </motion.div>
      )}

      <motion.div
        className={styles.Container}
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 1.5, ease: "easeOut" }}
      >
        {/* Section 1: Text Animations */}
        <motion.div
          className={`${styles.Section} ${styles.Section1}`}
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.2, delay: 0.3 }}
        >
          <SplitText
            text={acfData?.mainBrandContent?.toUpperCase() || "Default Brand"}
            as="p"
          />
          <SplitText text="STUDIO" as="h1" style={{ color: "#DC84FF" }} />
          <SplitText text="MAA MANGALA" as="h4" />
        </motion.div>

        {/* Section 2: Video Render */}
        <VideoCanvas videoSrc="https://studiomaamangala.com/wp-content/uploads/2025/02/drone.webm"  />

        {/* Section 3: Button & Circular Effect */}
        <motion.div
          className={`${styles.Section} ${styles.Section3}`}
          initial={{ opacity: 0, y: 50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 1.2, delay: 0.3 }}
        >
          <StarBorder
            as="button"
            color="cyan"
            speed="5s"
            className={styles.Visit}
            link="/contact"
          >
            Visit <br />
            <span>Now</span>
          </StarBorder>
          <motion.div
            className={styles.circleTextContainer}
            animate={{ rotate: 360 }}
            transition={{ duration: 10, repeat: Infinity, ease: "linear" }}
          />
        </motion.div>
      </motion.div>
    </motion.div>
  );
};

export default HeroHomeSec;
